export const LOADING_REQUEST = 'LOADING_START';
export const LOADING_SUCCESS = 'LOADING_SUCCESS';